//reviewAllowed
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ENewReviewFormReviewAllowed {
  Set = 'NEW_REVIEW/FORM/SET_REVIEW_ALLOWED',
}

export type TNewReviewReviewAllowed = ITypedReduxAction<ENewReviewFormReviewAllowed.Set, boolean>;

export type TNewReviewFormReviewAllowedActions = TNewReviewReviewAllowed;

export const setReviewAllowed = actionGenerator<ENewReviewFormReviewAllowed.Set, boolean>(
  ENewReviewFormReviewAllowed.Set,
);
